export const CUSTOMER_TYPES = {
  b2c: {
    value: '01',
    defaultValue: '01',
    label: 'Privatkunde',
  },
  b2b: {
    value: '02',
    defaultValue: '02',
    label: 'Geschäftskunde',
  },
  b2c_b2b: {
    value: '',
    defaultValue: '01',
    label: '',
  },
};
// todo possibly use object above to get options
// export const CUSTOMER_TYPES_OPTIONS = Object.values(CUSTOMER_TYPES).filter(
//   (customer) => customer.value !== '',
// );
export const CUSTOMER_TYPES_OPTIONS = [
  {
    value: '01',
    label: 'Privatkunden',
  },
  {
    value: '02',
    label: 'Geschäftskunden',
  },
];

export const PERSONS_COUNT_CONSUMPTION = [1000, 2500, 3500, 4000, 5000];
export const PERSONS_COUNT_CONSUMPTION_DEFAULT = 2500;

export const BUSINESS_SIZE_CONSUMPTION = [10000, 100000];
export const BUSINESS_SIZE_CONSUMPTION_DEFAULT = 15000;

export const GAS_BUSINESS_SIZE_CONSUMPTION = [30000, 500000];
export const GAS_BUSINESS_SIZE_CONSUMPTION_DEFAULT = 50000;

export const HOUSE_SIZE_TO_CONSUMPTION_MAPPING = {
  20: 2500,
  25: 3000,
  30: 3500,
  35: 4000,
  40: 4500,
  45: 5000,
  50: 6000,
  55: 7000,
  60: 8000,
  65: 9000,
  70: 10000,
  75: 11000,
  80: 12000,
  85: 13000,
  90: 14000,
  95: 15000,
  100: 16000,
  105: 17000,
  110: 18000,
  115: 19000,
  120: 20000,
  125: 21000,
  130: 22000,
  135: 23000,
  140: 24000,
  145: 25000,
  150: 26000,
  160: 27000,
  170: 30000,
  180: 33000,
  190: 36000,
  200: 40000,
  210: 45000,
  220: 50000,
  230: 55000,
};

export const HOUSE_SIZE_DEFAULT = 110;
